module.exports = __webpack_public_path__ + "img/mushroom_cloud.31f2d442.jpg";